// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__23XCD","obliqueLineWrap":"membershipbadge_obliqueLineWrap__24Dqn","obliqueLine":"membershipbadge_obliqueLine__2t8zn"};